(() => {
  'use strict';

  const global = typeof window === 'undefined' ? globalThis : window;
  const COLOR_WORDS = ['color', 'colour', 'カラー', '色'];
  const SIZE_WORDS = ['size', 'サイズ'];
  const pairImages = {
    goodold: {
      'オーセンティック': 'https://cdn.shopify.com/s/files/1/0777/0600/2685/files/journal-20260929-goodold-17.jpg?v=1790680402',
      'ロイヤルブルー': 'https://cdn.shopify.com/s/files/1/0777/0600/2685/files/journal-20260929-goodold-29.jpg?v=1790680410',
      'ブリティッシュスカイ': 'https://cdn.shopify.com/s/files/1/0777/0600/2685/files/journal-20260929-goodold-23.jpg?v=1790680406',
      'カンブリアグリーン': 'https://cdn.shopify.com/s/files/1/0777/0600/2685/files/journal-20260929-goodold-35.jpg?v=1790680415',
      'ヴィンテージブラック': 'https://cdn.shopify.com/s/files/1/0777/0600/2685/files/journal-20260929-goodold-41.jpg?v=1790680420'
    },
    audley: {
      'ロイヤルミルクティー': 'https://cdn.shopify.com/s/files/1/0777/0600/2685/files/journal-20260929-audrey-05.jpg?v=1790680425',
      'ブルーサファイア': 'https://cdn.shopify.com/s/files/1/0777/0600/2685/files/journal-20260929-audrey-11.jpg?v=1790680429'
    }
  };
  const pairs = {
    warm: {
      goodold: 'オーセンティック',
      audley: 'ロイヤルミルクティー',
      description: '深みのある茶色と、やさしいミルクティー色。\n同じ暖色でも、それぞれの個性がのぞく組み合わせ。'
    },
    blue: {
      goodold: 'ロイヤルブルー',
      audley: 'ブルーサファイア',
      description: '同じブルーの仲間でも、革が変われば表情も違う。\nさりげなく色を揃えて、ふたりらしいお揃いに。'
    }
  };
  const matchingPairKey = (colors, definitions = pairs) => {
    const productKeys = Object.keys(colors || {});
    if (!productKeys.length) return null;
    const match = Object.entries(definitions).find(([, pair]) => (
      productKeys.every((key) => pair[key] === colors[key])
    ));
    return match ? match[0] : null;
  };
  const previewProducts = {
    goodold: {
      options: [{ name: 'カラー' }, { name: 'サイズ' }],
      variants: [
        [71370008461565, 'オーセンティック', 'Lサイズ'],
        [71370008494333, 'オーセンティック', 'Mサイズ'],
        [71370008527101, 'ロイヤルブルー', 'Lサイズ'],
        [71370008559869, 'ロイヤルブルー', 'Mサイズ'],
        [71370008592637, 'ブリティッシュスカイ', 'Lサイズ'],
        [71370008625405, 'ブリティッシュスカイ', 'Mサイズ'],
        [71370008658173, 'カンブリアグリーン', 'Lサイズ'],
        [71370008690941, 'カンブリアグリーン', 'Mサイズ'],
        [71370008396029, 'ヴィンテージブラック', 'Lサイズ'],
        [71370008428797, 'ヴィンテージブラック', 'Mサイズ']
      ].map(([id, color, size]) => ({ id, options: [color, size], price: 1400000, available: false }))
    },
    audley: {
      options: [{ name: 'カラー' }, { name: 'サイズ' }],
      variants: [
        [71370312548605, 'ブルーサファイア', 'Mサイズ'],
        [71370312581373, 'ブルーサファイア', 'Sサイズ'],
        [71370312614141, 'ロイヤルミルクティー', 'Mサイズ'],
        [71370312646909, 'ロイヤルミルクティー', 'Sサイズ']
      ].map(([id, color, size]) => ({ id, options: [color, size], price: 1370000, available: false }))
    }
  };

  const makeError = (code, status) => Object.assign(new Error(code), { code, status });

  const normalizeRoot = (value) => {
    const trimmed = typeof value === 'string' ? value.trim() : '/';
    const leading = trimmed.startsWith('/') ? trimmed : '/' + trimmed;
    return (leading || '/').replace(/\/*$/, '/');
  };

  const optionName = (option) => {
    if (typeof option === 'string') return option;
    return option && typeof option.name === 'string' ? option.name : '';
  };

  const optionIndex = (product, words, fallback) => {
    const options = Array.isArray(product && product.options) ? product.options : [];
    const found = options.findIndex((option) => {
      const name = optionName(option).toLowerCase();
      return words.some((word) => name === word || name.includes(word));
    });
    return found >= 0 ? found : fallback;
  };

  const variantOptions = (variant) => {
    if (Array.isArray(variant && variant.options)) return variant.options;
    return [variant && variant.option1, variant && variant.option2, variant && variant.option3];
  };

  const findVariant = (product, color, size) => {
    if (!product || !Array.isArray(product.variants) || !color || !size) return null;
    const colorIndex = optionIndex(product, COLOR_WORDS, 0);
    const sizeIndex = optionIndex(product, SIZE_WORDS, 1);
    return product.variants.find((variant) => {
      const options = variantOptions(variant);
      return String(options[colorIndex]) === color && String(options[sizeIndex]) === size;
    }) || null;
  };

  const variantsForColor = (product, color) => {
    if (!product || !Array.isArray(product.variants) || !color) return [];
    const colorIndex = optionIndex(product, COLOR_WORDS, 0);
    return product.variants.filter((variant) => String(variantOptions(variant)[colorIndex]) === color);
  };

  const validVariantId = (value) => {
    const id = Number(value);
    return Number.isSafeInteger(id) && id > 0 ? id : null;
  };

  const cartResponseMatches = (payload, requestedIds) => {
    if (!payload || !Array.isArray(payload.items)) return false;
    const returned = payload.items
      .filter((item) => Number(item.quantity) > 0)
      .map((item) => validVariantId(item.variant_id || item.id))
      .filter(Boolean);
    return requestedIds.every((id) => returned.includes(id));
  };

  const createCartService = ({ fetchImpl, routesRoot = '/', navigate = () => {} }) => {
    const root = normalizeRoot(routesRoot);
    let submitting = false;

    const fetchProduct = async (handle) => {
      let response;
      try {
        response = await fetchImpl(root + 'products/' + encodeURIComponent(handle) + '.js', {
          method: 'GET',
          headers: { Accept: 'application/json' }
        });
      } catch (_error) {
        throw makeError('product_fetch');
      }
      if (response.status === 404) throw makeError('unpublished', 404);
      if (!response.ok) throw makeError('product_fetch', response.status);
      try {
        const product = await response.json();
        if (!product || !Array.isArray(product.variants)) throw new Error('invalid product');
        return product;
      } catch (_error) {
        throw makeError('product_fetch', response.status);
      }
    };

    const add = async (selections) => {
      if (submitting) return { status: 'busy' };
      submitting = true;
      try {
        if (!Array.isArray(selections) || selections.length === 0) throw makeError('invalid_variant');
        const products = await Promise.all(selections.map((selection) => fetchProduct(selection.handle)));
        const ids = products.map((product, index) => {
          const selection = selections[index];
          const variant = findVariant(product, selection.color, selection.size);
          const id = variant && validVariantId(variant.id);
          if (!id) throw makeError('invalid_variant');
          if (variant.available !== true) throw makeError('unavailable');
          return id;
        });

        let response;
        try {
          response = await fetchImpl(root + 'cart/add.js', {
            method: 'POST',
            headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: ids.map((id) => ({ id, quantity: 1 })) })
          });
        } catch (_error) {
          throw makeError('cart_network');
        }
        if (!response.ok) throw makeError('cart_rejected', response.status);
        let payload;
        try {
          payload = await response.json();
        } catch (_error) {
          throw makeError('unknown_response', response.status);
        }
        if (!cartResponseMatches(payload, ids)) throw makeError('unknown_response', response.status);
        navigate(root + 'cart');
        return { status: 'success', ids };
      } finally {
        submitting = false;
      }
    };

    return { add, fetchProduct, isSubmitting: () => submitting };
  };

  if (global.__CM_JOURNAL_TEST__) {
    global.CMJournalCartTest = { cartResponseMatches, createCartService, findVariant, matchingPairKey, normalizeRoot };
  }

  if (typeof document === 'undefined') return;

  const routesRoot = normalizeRoot(global.Shopify && global.Shopify.routes && global.Shopify.routes.root);
  const formatMoney = (cents) => {
    const value = Number(cents);
    if (!Number.isFinite(value)) return '';
    const currency = global.Shopify && global.Shopify.currency && global.Shopify.currency.active || 'JPY';
    try {
      return new Intl.NumberFormat('ja-JP', { style: 'currency', currency, maximumFractionDigits: 0 }).format(value / 100);
    } catch (_error) {
      return '¥' + Math.round(value / 100).toLocaleString('ja-JP');
    }
  };

  const setStatus = (element, message, state = '') => {
    if (!element) return;
    element.textContent = message;
    if (state) element.dataset.state = state;
    else delete element.dataset.state;
  };

  const initializeHero = (root) => {
    const heroVideo = root.querySelector('#hero-video');
    const videoToggle = root.querySelector('.video-toggle');
    if (!heroVideo || !videoToggle || heroVideo.dataset.journalReady === 'true') return;
    heroVideo.dataset.journalReady = 'true';
    const updateVideoButton = () => {
      videoToggle.innerHTML = heroVideo.paused ? '▶ <span>PLAY</span>' : 'Ⅱ <span>PAUSE</span>';
      videoToggle.setAttribute('aria-label', heroVideo.paused ? '動画を再生' : '動画を一時停止');
    };
    videoToggle.addEventListener('click', () => {
      if (heroVideo.paused) heroVideo.play().catch(() => {});
      else heroVideo.pause();
    });
    heroVideo.addEventListener('play', updateVideoButton);
    heroVideo.addEventListener('pause', updateVideoButton);
    if (global.matchMedia && global.matchMedia('(prefers-reduced-motion: reduce)').matches) heroVideo.pause();
    updateVideoButton();
  };

  const initializeCart = (root) => {
    const section = root.querySelector('.together[data-cart-mode]');
    if (!section || section.dataset.cartReady === 'true') return;
    section.dataset.cartReady = 'true';
    const mode = section.dataset.cartMode;
    const globalStatus = section.querySelector('[data-cart-status]');
    const addBoth = section.querySelector('[data-cart-add-both]');
    const cardElements = Array.from(section.querySelectorAll('.pair-product[data-product-key]'));
    if (!addBoth || cardElements.length !== 2) return;
    const cards = new Map();
    let uiBusy = false;

    cardElements.forEach((element) => {
      cards.set(element.dataset.productKey, {
        element,
        key: element.dataset.productKey,
        handle: element.dataset.productHandle,
        color: element.querySelector('[data-product-color]'),
        size: element.querySelector('[data-product-size]'),
        image: element.querySelector('img'),
        colorName: element.querySelector('figcaption b'),
        price: element.querySelector('[data-product-price]'),
        stock: element.querySelector('[data-product-stock]'),
        add: element.querySelector('[data-cart-add]'),
        product: null,
        error: null,
        selection: null
      });
    });

    const service = mode === 'shopify' && typeof global.fetch === 'function'
      ? createCartService({
          fetchImpl: global.fetch.bind(global),
          routesRoot,
          navigate: (url) => { global.location.assign(url); }
        })
      : null;

    const updateImage = (card) => {
      const source = pairImages[card.key] && pairImages[card.key][card.color.value];
      if (source && card.image) card.image.src = source;
      if (card.image) card.image.alt = (card.key === 'goodold' ? 'グッドオールド ' : 'オードリーカーフ ') + card.color.value;
      if (card.colorName) card.colorName.textContent = card.color.value;
    };

    const evaluateCard = (card) => {
      card.selection = null;
      updateImage(card);
      if (card.error === 'unpublished') {
        setStatus(card.stock, '販売開始前', 'unavailable');
        card.add.disabled = true;
        return;
      }
      if (card.error) {
        setStatus(card.stock, '商品情報を取得できません', 'error');
        card.add.disabled = true;
        return;
      }
      if (!card.product) {
        setStatus(card.stock, '商品情報を確認しています', 'loading');
        card.add.disabled = true;
        return;
      }

      const colorVariants = variantsForColor(card.product, card.color.value);
      const selected = findVariant(card.product, card.color.value, card.size.value);
      const priceVariant = selected || colorVariants[0] || card.product.variants[0];
      if (priceVariant && card.price) {
        const formatted = formatMoney(priceVariant.price);
        if (formatted) card.price.innerHTML = formatted + ' <small>（税込）</small>';
      }

      if (!colorVariants.length || colorVariants.every((variant) => variant.available !== true)) {
        setStatus(card.stock, '×（在庫なし）', 'unavailable');
      } else if (!card.size.value) {
        setStatus(card.stock, 'サイズを選択してください');
      } else if (!selected) {
        setStatus(card.stock, '選択内容を確認できません', 'error');
      } else if (selected.available !== true) {
        setStatus(card.stock, '×（在庫なし）', 'unavailable');
      } else {
        setStatus(card.stock, '在庫あり', 'available');
        card.selection = { handle: card.handle, color: card.color.value, size: card.size.value };
      }
      card.add.disabled = uiBusy || !card.selection;
    };

    const render = () => {
      cards.forEach(evaluateCard);
      addBoth.disabled = uiBusy || !cards.size || Array.from(cards.values()).some((card) => !card.selection);
    };

    const setBusy = (busy) => {
      uiBusy = busy;
      section.setAttribute('aria-busy', String(busy));
      render();
    };

    const syncPairPresentation = () => {
      const colors = {};
      cards.forEach((card, key) => { colors[key] = card.color.value; });
      const activePair = matchingPairKey(colors);
      const description = section.querySelector('#pair-description');
      if (description) {
        description.textContent = activePair
          ? pairs[activePair].description
          : 'それぞれの好きな色を並べて。\nふたりらしい組み合わせを。';
      }
      section.querySelectorAll('[data-pair]').forEach((item) => {
        const selected = item.dataset.pair === activePair;
        item.classList.toggle('active', selected);
        item.setAttribute('aria-pressed', String(selected));
      });
    };

    const focusMissingSize = (selectedCards) => {
      const card = selectedCards.find((item) => !item.size.value);
      if (!card) return false;
      setStatus(card.stock, 'サイズを選択してください');
      card.size.focus();
      return true;
    };

    const errorMessage = (error) => {
      if (error && error.code === 'unpublished') return '商品は販売開始前です。';
      if (error && error.code === 'unavailable') return '選択した商品は×（在庫なし）です。';
      if (error && error.code === 'invalid_variant') return '選択内容を確認できませんでした。カラーとサイズをご確認ください。';
      if (error && error.code === 'cart_rejected') return '在庫状況が変わったため、カートに追加できませんでした。';
      if (error && error.code === 'product_fetch') return '商品情報を取得できません。時間をおいてお試しください。';
      return 'カートへの追加を確認できませんでした。';
    };

    const showUncertainCartStatus = () => {
      setStatus(globalStatus, '追加を確認できませんでした。再度追加する前にカートをご確認ください。', 'error');
      const link = document.createElement('a');
      link.className = 'pair-cart-link';
      link.href = routesRoot + 'cart';
      link.textContent = 'カートを確認する →';
      globalStatus.append(document.createElement('br'), link);
    };

    const submit = async (selectedCards) => {
      if (!service || uiBusy || focusMissingSize(selectedCards)) return;
      const selections = selectedCards.map((card) => card.selection).filter(Boolean);
      if (selections.length !== selectedCards.length) {
        setStatus(globalStatus, '在庫のあるカラーとサイズを選択してください。', 'error');
        return;
      }
      setBusy(true);
      setStatus(globalStatus, '在庫を確認してカートに追加しています。');
      let succeeded = false;
      try {
        const result = await service.add(selections);
        if (result && result.status === 'success') succeeded = true;
        else setStatus(globalStatus, '処理中です。しばらくお待ちください。');
      } catch (error) {
        if (error && (error.code === 'cart_network' || error.code === 'unknown_response')) {
          showUncertainCartStatus();
        } else {
          setStatus(globalStatus, errorMessage(error), 'error');
        }
      } finally {
        if (!succeeded) setBusy(false);
      }
    };

    cards.forEach((card) => {
      card.color.addEventListener('change', () => {
        syncPairPresentation();
        render();
      });
      card.size.addEventListener('change', render);
      card.add.addEventListener('click', () => submit([card]));
    });
    addBoth.addEventListener('click', () => submit(Array.from(cards.values())));

    section.querySelectorAll('[data-pair]').forEach((button) => {
      button.addEventListener('click', () => {
        const pair = pairs[button.dataset.pair];
        if (!pair) return;
        cards.forEach((card, key) => { card.color.value = pair[key]; });
        syncPairPresentation();
        render();
      });
    });

    if (!service && mode === 'preview') {
      cards.forEach((card, key) => { card.product = previewProducts[key]; });
      setStatus(globalStatus, 'ローカルプレビューでは、色合わせのみご確認いただけます。購入操作はShopify上で有効になります。');
      render();
      return;
    }

    if (!service) {
      cards.forEach((card) => { card.error = 'product_fetch'; });
      setStatus(globalStatus, '商品情報を取得できません。時間をおいてお試しください。', 'error');
      render();
      return;
    }

    render();
    Promise.all(Array.from(cards.values()).map(async (card) => {
      try {
        card.product = await service.fetchProduct(card.handle);
      } catch (error) {
        card.error = error && error.code || 'product_fetch';
      }
      render();
    })).then(() => {
      const values = Array.from(cards.values());
      if (values.some((card) => card.error === 'product_fetch')) {
        setStatus(globalStatus, '一部の商品情報を取得できません。', 'error');
      } else if (values.every((card) => card.error === 'unpublished')) {
        setStatus(globalStatus, '商品は販売開始前です。');
      } else if (values.every((card) => card.product && card.product.variants.every((variant) => variant.available !== true))) {
        setStatus(globalStatus, '現在、選択できる商品は×（在庫なし）です。');
      } else {
        setStatus(globalStatus, 'カラーとサイズを選んでカートへ進んでください。');
      }
    });
  };

  const initialize = (root) => {
    if (!root || typeof root.querySelector !== 'function') return;
    initializeHero(root);
    initializeCart(root);
  };

  const initializeAll = () => {
    const roots = Array.from(document.querySelectorAll('#cm-journal-20260929'));
    if (roots.length) roots.forEach(initialize);
    else initialize(document);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll, { once: true });
  else initializeAll();

  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.matches && event.target.matches('#cm-journal-20260929')
      ? event.target
      : event.target.querySelector && event.target.querySelector('#cm-journal-20260929');
    initialize(root);
  });
})();
